import React, {useState, useContext, useEffect} from 'react';
import { IonText, IonGrid, IonRow, IonCol, IonButton, IonModal, IonContent, IonList, IonItem, IonInfiniteScroll, IonInfiniteScrollContent, IonHeader, IonFooter, IonTabs, IonTabBar, IonRouterOutlet, IonTabButton, IonLabel } from '@ionic/react';
import ReactDOM from 'react-dom';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';
// import { ViewDepositsModal_Paid_In_Full } from './Modal_ViewDeposits_Paid_In_Full';
// import { ViewDepositsModal_Paid_Partial } from './Modal_ViewDeposits_Paid_Partial';

import '../../../../css/qavaApp.css';

const Backdrop = props => {
    return <div className='backdrop'/>
};

export function ViewDepositsModal (props) {


    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    let [startDate, setStartDate] = useState(props.startDate);
    let [endDate, setEndDate] = useState(props.endDate);

    let [viewModal_paid_in_full, setViewModal_paid_in_full] = useState(true);
    let [viewModal_paid_partial, setViewModal_paid_partial] = useState(false);

    let [paidInFullColor, setpaidInFullColor] = useState('solid')
    let [paidPartialColor, setPaidPartialColor] = useState('outline');

    function paidInFullHandler()
    {
        setViewModal_paid_partial(false);
        setViewModal_paid_in_full(true);
        setpaidInFullColor('solid');
        setPaidPartialColor('outline');
    }

    function paidPartialHandler()
    {
        setViewModal_paid_partial(true);
        setViewModal_paid_in_full(false);
        setpaidInFullColor('outline');
        setPaidPartialColor('solid');

    }

    return (

        <React.Fragment> 
        <IonModal isOpen={ props.openModal }>
            <IonHeader>
                <IonGrid>
                    <IonRow>
                        <IonCol size='6'>
                            <IonButton fill={paidInFullColor} onClick={() => paidInFullHandler()}> Paid In Full </IonButton>
                        </IonCol>
                        <IonCol size='6'>
                            <IonButton fill={paidPartialColor} onClick={() => paidPartialHandler()}> Paid Partial </IonButton>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonHeader>

            <IonContent className='appGridContent'>


               {/*} {viewModal_paid_partial == true && <ViewDepositsModal_Paid_Partial startDate={props.startDate} endDate={props.endDate} closeModal={() => setViewModal_paid_partial(false)}></ViewDepositsModal_Paid_Partial>}
                {viewModal_paid_in_full == true && <ViewDepositsModal_Paid_In_Full startDate={props.startDate} endDate={props.endDate} closeModal={() => setViewModal_paid_in_full(false)}></ViewDepositsModal_Paid_In_Full>}*/}

            </IonContent>

            <IonFooter className='modal_footer_button_center'>
                <IonButton onClick={() => props.closeModal()}> Close </IonButton>
            </IonFooter>
        </IonModal>

        </React.Fragment>

    )
}